module.exports = "{{'copyRightsReserved' | translate}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main